<template>
    <div id="appLayout">
        <google-one-tap></google-one-tap>
        <mobile-overlay></mobile-overlay>

        <top-nav v-if="!this.$route.meta || !this.$route.meta.noNav"></top-nav>
        <b-container :fluid="this.$route.meta.fluidLayout">
            <loading :active.sync="$root.isLoading"
                     :is-full-page="true"
            ></loading>
            <router-view></router-view>
        </b-container>
    </div>
</template>

<script>
    import TopNav from "../navs/top-nav";
    import MobileOverlay from "./mobile-overlay";
    import { notifications } from "../../mixins/notifications";
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'app-layout',
        mixins: [notifications],
        components: {MobileOverlay, TopNav},
        updated() {
            if (this.globalNotification.message) {
                this.pushNotification(this.globalNotification.message, this.globalNotification.type);
                this.resetGlobalNotification();
            }
        },
        computed: {
            ...mapGetters({
                globalNotification: 'globalNotification'
            })
        },
        methods: {
            ...mapMutations({
                resetGlobalNotification: 'resetGlobalNotification'
            }),
        }
    }
</script>

<style scoped>

</style>
